import React, { useEffect, useState } from 'react';
import './css/results.scss';
import WinnerSerials from './elements/winnerSerials';
import apiDraw from '../api/draw';
import moment from 'moment';

const Results = () => {
  const [winner, setWinner] = useState(null);
  const [draw, setDraw] = useState(null);
  const [renderList, setRenderList] = useState([]);

  const handleGetPublishWinners = async () => {
    try {
      const data = await apiDraw.findByPublishWinners();
      const response = data.data;
      setWinner(response.winner);
      setDraw(response.draw);
      const filter = [];
      response.winner.andinito.forEach((i) => {
        const formattedNumber = i < 10 ? `0${i}` : i.toString();
        filter.push(formattedNumber);
      });
      if (filter.length !== 0) {
        const res = filter.map((item) => <span>{item}</span>);
        setRenderList(res);
      }
    } catch (error) {}
  };


  
  const formatDateLocal = (date) => {
    return moment(date).format('DD/MM/YY')
  }


  useEffect(() => {
    handleGetPublishWinners();
  }, []);

  return (
    <div className="results">
      {renderList.length !== 0 && (
        <>
      <h2>RESULTADO DEL SORTEO Nro.{draw !== null ? `000${draw._id}` : ''}</h2>
      <h2>{draw !== null ? formatDateLocal(draw.endDate) : ''}</h2>
      <div className="results-number">
        {renderList.length !== 0 ? renderList : ''}
        {/*<span className="bronze">{especialResults[0]}</span>
        <span className="silver">{especialResults[1]}</span>
        <span className="golden">{especialResults[2]}</span>*/}
      </div>
      <div className="results-serials">
      <WinnerSerials/>
      </div>
      </>
      )}
    </div>
  );
};

export default Results;
